import { Component, OnInit, OnDestroy } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Unsubscribable, fromEvent } from 'rxjs';
import { CategoryService } from '../_service/category/category.service';
import { GenreService } from '../_service/genre/genre.service';
import { VideoListService } from '../_service/video/video-list.service';
import { RandomVideosService } from '../_service/video/random-videos.services';
import { ClassifiedTopVideosService } from '../_service/video/classified-top-videos.services';
import { SeoService } from '../seoservice/seoservice';
import { StorageService } from 'app/storageprovider';
import { DnFocusesService } from 'app/_service/dn-focus/dn-focus.service';
import { animateDebounce } from '../_service/animateDebounce';
@Component({
  selector: 'app-subindex',
  templateUrl: './subindex.component.html',
  styleUrls: ['./subindex.component.scss'],
  providers: [GenreService, CategoryService]
})

export class SubindexComponent implements OnInit, OnDestroy {
  subscriptions: Array<Unsubscribable> = [];
  currentCategory;
  currentUrl;
  recentAdded;
  guessYouLikeVideos;
  guessYouLikeTotal = 24;
  guessYouLikePageIndex = 0;
  guessYouLikePageSize = 8;
  genres;
  contentLoading;
  //fitems: Array<any> = [];
  constructor(
    private _route: ActivatedRoute,
    private _categoryService: CategoryService,
    private _genreService: GenreService,
    private _titleService: SeoService,
    private _videoListService: VideoListService,
    private _randomVideosService: RandomVideosService,
    private _classifiedTopVideosService: ClassifiedTopVideosService,
  ) {

  }

  dataList = {};
  ngOnInit() {

    //this.currentUrl = this._router.url.split('?')[0].substr(1).split('/')[0];
    //this.setCurrentCategory();

    this.subscriptions.push(
      this._route.params.subscribe(params => {
        this.currentUrl = params.route;
        this.setCurrentCategory();
        //this.getRandomVideos();
        //this.getClassifiedTopVideosVideos();
      })
      // this._router.events.subscribe(e => {
      //   if (e instanceof NavigationEnd) {
      //     this.currentUrl = this._router.url.split('/').filter(item => item !== '')[0];
      //     this.setCurrentCategory();
      //   }
      // })
    );
    this.subscriptions.push(
      this._classifiedTopVideosService.classifiedTopVideos$.subscribe(list => {
        this.dataList = {};
        if (list.length > 0) {
          this.listToLoad = list[0].lists as Array<any>;
          this.flowControl(true);
          // const toLoadList = this.listToLoad;
          // for(let i = 0; i < toLoadList.length; i++) {
          //   const toLoad = toLoadList[i];
          // }

        }
        // else {
        //   this.dataList = {};
        // }
      }),

      //fromEvent(window, "scroll", { passive: true }).subscribe(animateDebounce(this.onWindowScroll.bind(this)).bind(this))

    )

  }

 // disableHover = false;
  //timer = null;
  onWindowScroll() {
    // clearTimeout(this.timer);
    // this.disableHover = true;
    // this.timer = setTimeout(() => {
    //   this.disableHover = false;
    // }, 200);

  }
  slug = '';
  timeout = null;
  listToLoad = [];
  flowControl(immedetaly = false) {
    // if (this.timeout) {
    //   clearTimeout(this.timeout);
    // }
    this.timeout = setTimeout(() => {
      var toLoad = this.listToLoad.shift();
      if (toLoad != null)
        this.dataList[toLoad.cid + "List"] = toLoad.items;
      if (this.listToLoad.length > 0) {
        this.flowControl();
      }
    }, immedetaly ? 0 : 200);
  }
  seoData = [
    {
      "path": "movie",
      "context": {
          "title": "电影频道-惊险、浪漫、经典尽在眼前-{SiteName}",
          "description": "{SiteName}电影频道，畅览电影世界的魅力，爱壹帆电影频道为您带来精彩的影片，包括惊险刺激、浪漫感人、经典回顾，让您的电影时光更加丰富多彩！",
          "keywords": "喜剧,爱情,动作,犯罪,科幻,奇幻,冒险,灾难,惊悚,剧情,战争,歌舞,经典,悬疑,动画"
      }
  },
  {
    "path": "variety",
    "context": {
        "title": "综艺频道-欢笑、感动、明星精彩绽放-{SiteName}",
        "description": "{SiteName}综艺频道,独特的综艺节目，爱壹帆综艺频道为您呈现欢乐搞笑、感动瞬间、明星光芒，保证让您笑出声，感动流泪，丰富多彩的娱乐体验！",
        "keywords": "真人秀,选秀,网综,脱口秀,搞笑,竞技,情感,访谈,演唱会,晚会,其他"
    }
  },
    {
      "path": "drama",
      "context": {
        "title": "电视剧频道-精彩剧集，扣人心弦的戏剧人生-{SiteName}",
        "description": "{SiteName}电视剧频道，剧迷的天堂，爱壹帆电视剧频道为您带来最新热门的电视剧，扣人心弦的情节，感受戏剧的魅力，陪您度过细水长流的视觉盛宴！",
        "keywords": "国产剧,港台剧,欧美剧,美剧,英剧,韩剧,日剧,新马泰"
      }
    },
    {
      "path": "anime",
      "context": {
        "title": "动漫频道-热血、梦幻、动漫世界的奇妙之旅-{SiteName}",
        "description": "{SiteName}动漫，动漫迷的天堂，爱壹帆动漫频道带您走进梦幻的动漫世界，感受热血青春、奇幻冒险，陪您重温经典，发现新的追逐！",
        "keywords": "热血,格斗,机战,少女,竞技,科幻,魔幻,爆笑,推理,灵异,动画"
      }
    },
    {
      "path": "documentary",
      "context": {
        "title": "纪录片频道-探索、启发、真实世界的奇迹-{SiteName}",
        "description": "{SiteName}纪录片，好奇的目光，爱壹帆纪录片频道为您带来精彩的纪录片，探索神奇的世界，启发智慧，感受真实与奇迹并存的探索之旅！",
        "keywords": "文化,探索,军事,解密,科技,历史,人物,自然,其它"
      }
    },
  ];

  setCurrentCategory() {

    this._categoryService.getCategoryByUrl(this.currentUrl).subscribe(res => {
   
      this.currentCategory = res[0];
      this.slug = this.currentCategory.slug;
      let seoContext = this.seoData.filter(p=>p.path == this.currentCategory.slug);
      let context:any = {};
      if(seoContext.length>0)
      {
        context = seoContext[0].context;
      }
      this._titleService.setTitle(context.title||(this.currentCategory.title+"频道"));
      this._videoListService.getRecentAddedVideos(this.currentCategory.cid).subscribe(r => {
        this.recentAdded = r;
      })
      this.getClassifiedTopVideosVideos();
      this.refreshGuessYouLikeVideos();
      this.subscriptions.push(
        this._genreService.getGenres(this.currentCategory.cid, true, true, true).subscribe(genres => {
          this.genres = genres;
          if (this.genres != null && this.genres.length) {
            var result = "";
            for (var i = 0; i < this.genres.length; ++i) {
              result = result + (result ? " / " : "") + this.genres[i].title;
              let data = this.genres[i].id.split(',');
              if (data.length == 4) {
                this.genres[i].index = data[data.length - 1];
              }

            }
            this._titleService.setDescription(context.description || result);

          }
        })
      );
      // if(this.currentCategory.id == 2)
      // {
      //     var list = this._menuService.getMenuItemByCid("0,1,4");
      //     console.log(list)
      // }
      // else
      // {
      //   this.subscriptions.push(
      //     this._genreService.getGenres(this.currentCategory.id, true).subscribe(genres => {
      //       this.genres = genres;
      //       // console.log(this.genres)
      //       if (this.genres != null && this.genres.length) {
      //         var result = "";
      //         for (var i = 0; i < this.genres.length; ++i) {
      //           result = result + (result ? " / " : "") + this.genres[i].title;
      //         }
      //         // console.log(result);
      //         this._titleService.setDescription(result)
      //       }
      //     })
      //   );
      // }
    });
  }

  // getRandomVideos() {
  //   this.subscriptions.push(
  //     this._randomVideosService.randomVideosSource$.subscribe(r => {
  //       if (!r.find(c => c.cid === this.currentCategory.cid)) {
  //         this._randomVideosService.updateRandomVideos(this.currentCategory.cid);
  //       }
  //     })
  //   );
  // }

  getClassifiedTopVideosVideos() {
    this._classifiedTopVideosService.updateClassifiedTopVideos(this.currentCategory.cid);

    // this.subscriptions.push(
    //   this._classifiedTopVideosService.classifiedTopVideos$.subscribe(r => {
    //     if (!r.find(c => c.cid === this.currentCategory.cid)) {
    //     }
    //   })
    // );
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
    clearTimeout(this.timeout);
  }

  getRecommendedVideos(id) {
    const genre = this.genres.filter(g => {
      return g.id === id;
    });
    if (genre[0]['top-videos']) {
      return genre[0]['top-videos'];
    } else {
      return [];
    }
  }

  refreshGuessYouLikeVideos() {
    this.contentLoading = true;
    this.subscriptions.push(
      this._videoListService.getGuessYouLikeVideos(this.currentCategory.cid).subscribe(r => {
        this.contentLoading = false;

        const start = (this.guessYouLikePageIndex % this.guessYouLikePageSize) * this.guessYouLikePageSize;
        this.guessYouLikeVideos = r.splice(start, start + this.guessYouLikePageSize);
        this.guessYouLikePageIndex += 1;
        if (this.guessYouLikePageIndex === 4) {
          this.guessYouLikePageIndex = 0;
        }
      })
    );
  }

  // shuffle(a) {
  //   for (let i = a.length - 1; i > 0; i--) {
  //     const j = Math.floor(Math.random() * (i + 1));
  //     [a[i], a[j]] = [a[j], a[i]];
  //   }
  //   return a;
  // }
}
